import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import VehicleList from './components/VehicleList';
import VehicleDetail from './components/VehicleDetail';
import RentalInformationPage from './components/RentalInformationPage';
import RentalCatalogue from './components/RentalCatalogue';
import RentalVehicleDetail from './components/RentalVehicleDetail';
import QuoteForm from './components/QuoteForm';
import Cars from './components/Cars';
import Vans from './components/Vans';
import Trucks from './components/Trucks';
import NewTrucks from './components/NewTrucks';
import UsedTrucks from './components/UsedTrucks';
import CarLeasing from './components/CarLeasing';
import CarFinance from './components/CarFinance';
import NewCars from './components/NewCars';
import UsedCars from './components/UsedCars';
import UsedVans from './components/UsedVans';
import NewVans from './components/NewVans';
import VanFinance from './components/VanFinance';
import VanLeasing from './components/VanLeasing';
import Cookies from './components/Cookies';
import Complaints from './components/Complaints';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import Tcf from './components/Tcf';
import VehicleSearch from './components/VehicleSearch'; // Import the search component

function RouteMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const names = { '/': 'Ford Van Rental & Hire', '/van-rental': 'Daily, Weekly & 28-Day Van Rental', '/van-hire': '3–12 Month Van Hire', '/request-a-quote': 'Request a Van Quote', '/our-vans': 'Explore Our Ford Vans', '/our-vans/ford/transit-custom': 'Ford Transit Custom Rental & Hire', '/electric-hybrid-vans': 'Electric & Plug-in Hybrid Vans', '/contact': 'Contact Our Liverpool Team', '/business-van-hire': 'Business & Fleet Van Hire' };
    document.title = `${names[pathname] || 'Ford Vans & Vehicle Enquiries'} | Vanir Motor Group`;
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export function AppRoutes() {
  return (
    <>
      <RouteMetadata />
      <a href="#main-content" className="rental-skip-link">Skip to content</a>
      {process.env.REACT_APP_STAGING === 'true' && <div className="staging-notice">Staging preview · Vehicle supply and prices to be confirmed · Test enquiries are saved without sending emails</div>}
      <Header />
      <div id="main-content" className="rental-main" tabIndex="-1">
      <Routes>
        {/* Core Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<RentalInformationPage page="about" />} />
        <Route path="/contact" element={<RentalInformationPage page="contact" />} />
        <Route path="/van-rental" element={<RentalCatalogue mode="rental" />} />
        <Route path="/van-hire" element={<RentalCatalogue mode="hire" />} />
        <Route path="/our-vans" element={<RentalCatalogue />} />
        <Route path="/our-vans/ford/transit-custom" element={<RentalCatalogue />} />
        <Route path="/our-vans/ford/transit-custom/:variant" element={<RentalVehicleDetail />} />
        <Route path="/electric-hybrid-vans" element={<RentalCatalogue mode="electric" />} />
        <Route path="/business-van-hire" element={<RentalInformationPage page="business" />} />
        <Route path="/request-a-quote" element={<QuoteForm />} />
        <Route path="/extend-your-hire" element={<RentalInformationPage page="extension" />} />
        <Route path="/vehicle-sales" element={<RentalInformationPage page="sales" />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/complaints" element={<Complaints />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/tcf" element={<Tcf />} />

        {/* Vehicle-Specific Routes */}
        <Route path="/vehicles" element={<VehicleList />} />
        <Route path="/vehicles/:id" element={<VehicleDetail />} />

        {/* Cars Section */}
        <Route path="/cars/*" element={<Cars />} />
        <Route path="/cars/leasing" element={<CarLeasing />} />
        <Route path="/cars/finance" element={<CarFinance />} />
        <Route path="/cars/new" element={<NewCars />} />
        <Route path="/cars/used" element={<UsedCars />} />

        {/* Vans Section */}
        <Route path="/vans/*" element={<Vans />} />
        <Route path="/vans/used" element={<UsedVans />} />
        <Route path="/vans/new" element={<NewVans />} />
        <Route path="/vans/finance" element={<VanFinance />} />
        <Route path="/vans/leasing" element={<VanLeasing />} />

        {/* Trucks Section */}
        <Route path="/trucks/*" element={<Trucks />} />
        <Route path="/trucks/new" element={<NewTrucks />} />
        <Route path="/trucks/used" element={<UsedTrucks />} />

        {/* Search Functionality for Vehicle Types */}
        <Route path="/car-search" element={<VehicleSearch searchType="car" />} />
        <Route path="/van-search" element={<VehicleSearch searchType="van" />} />
        <Route path="/truck-search" element={<VehicleSearch searchType="truck" />} />
        <Route path="*" element={<RentalInformationPage page="missing" />} />
      </Routes>
      </div>
      <Footer />
    </>
  );
}

function App() { return <Router><AppRoutes /></Router>; }

export default App;
